import React from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from "@/components/ui/dialog";
import { Trash2, AlertTriangle } from "lucide-react";

interface ClearFavoritesConfirmModalProps {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void;
  count: number;
}

export const ClearFavoritesConfirmModal: React.FC<ClearFavoritesConfirmModalProps> = ({
  isOpen,
  onOpenChange,
  onConfirm,
  count,
}) => {
  return (
    <Dialog open={isOpen} onOpenChange={onOpenChange}>
      <DialogContent className="w-[calc(100vw-1.5rem)] max-w-sm sm:max-w-md bg-slate-900 border border-slate-800 text-white p-4 sm:p-6 rounded-2xl sm:rounded-3xl shadow-2xl backdrop-blur-xl">
        <DialogHeader className="text-left space-y-2">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-xl bg-rose-500/15 border border-rose-500/30 flex items-center justify-center text-rose-400 flex-shrink-0">
              <Trash2 className="w-5 h-5" />
            </div>
            <div>
              <DialogTitle className="text-base sm:text-lg font-bold text-white tracking-tight">
                Vider les favoris
              </DialogTitle>
              <DialogDescription className="text-xs sm:text-sm text-slate-400">
                {count > 0 ? (
                  <>
                    Voulez-vous réinitialiser votre liste de{" "}
                    <span className="text-rose-400 font-semibold">{count}</span>{" "}
                    cantique{count > 1 ? "s" : ""} favori{count > 1 ? "s" : ""} ?
                  </>
                ) : (
                  "Voulez-vous réinitialiser votre liste de favoris ?"
                )}
              </DialogDescription>
            </div>
          </div>
        </DialogHeader>

        <div className="p-3 rounded-xl bg-slate-950/80 border border-slate-800/80 text-xs text-slate-300 flex items-start gap-2.5 mt-1">
          <AlertTriangle className="w-4 h-4 text-amber-400 flex-shrink-0 mt-0.5" />
          <p className="leading-relaxed">
            Cette action supprimera tous vos cantiques enregistrés sur cet appareil.
          </p>
        </div>

        {/* Action Buttons */}
        <div className="flex items-center justify-end gap-2.5 mt-3 pt-2 border-t border-slate-800/60">
          <button
            type="button"
            onClick={() => onOpenChange(false)}
            className="px-3.5 py-2 rounded-xl bg-slate-800/90 hover:bg-slate-700 text-slate-300 hover:text-white text-xs font-semibold border border-slate-700/80 transition-all cursor-pointer"
          >
            Annuler
          </button>
          <button
            type="button"
            onClick={() => {
              onConfirm();
              onOpenChange(false);
            }}
            className="inline-flex items-center gap-1.5 px-4 py-2 rounded-xl bg-rose-600 hover:bg-rose-500 text-white text-xs font-bold shadow-lg shadow-rose-600/25 transition-all cursor-pointer hover:scale-102 active:scale-98"
          >
            <Trash2 className="w-3.5 h-3.5" />
            <span>Oui, réinitialiser</span>
          </button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
